import { createContext, useContext } from "react";
import { Platform, View } from "react-native";

export interface LayoutContextState {
  scrollTo: (y: number, smooth?: boolean) => void;
}

export const LayoutContext = createContext<LayoutContextState>({
  scrollTo: (top, smooth) => {
    if (Platform.OS === "web")
      window.scrollTo({ top, behavior: smooth ? "smooth" : undefined });
  },
});
export const useLayoutContext = () => useContext(LayoutContext);
